export default "__VITE_ASSET__Mz1PGqpB__"